export default "__VITE_ASSET__Bo934UwD__"